export default function handleRedirectToCommunity(params) {
  const tenantNameRaw = params.get("tenantName") || "";
const tenantIdRaw = params.get("tenantId") || "";

const tenantId = tenantIdRaw ? Number(tenantIdRaw.replace(/,/g, "")) : null;

  let tenantName = "";

  try {
    // New format: Base64 encoded
    tenantName = tenantNameRaw
      ? decodeURIComponent(atob(tenantNameRaw))
      : "";
  } catch (error) {
    // Old format fallback: + converted to spaces
    tenantName = decodeURIComponent(
      tenantNameRaw.replace(/\+/g, " ")
    );
  }

  return {
    action: "redirectToCommunity",
    tenantName,
    tenantId
  };
}